import React from 'react';
import { Lock } from 'lucide-react';

/** Stage-modal section banner — same look in every stage so sections read as separate blocks. */
export const SectionHeader = ({ title, locked = false, note = null, compact = false }) => (
  <div
    className={`${compact ? 'mb-3' : 'mb-4'} rounded-lg border-l-4 border-blue-500 bg-blue-800 dark:bg-blue-900 px-4 py-2.5 shadow-md`}
    data-testid={`section-header-${title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
  >
    <div className="flex flex-wrap items-center justify-between gap-2">
      <h3
        className={`${compact ? 'text-base' : 'text-lg'} font-bold uppercase tracking-wide text-white`}
      >
        {title}
      </h3>
      <div className="flex items-center gap-2">
        {note && (
          <span className="text-[10px] font-semibold text-blue-700 dark:text-blue-200 bg-white/80 dark:bg-blue-950/60 border border-blue-300 dark:border-blue-700 rounded-full px-2 py-0.5">
            {note}
          </span>
        )}
        {locked && (
          <span
            className="flex items-center gap-1 text-[10px] font-semibold text-white bg-red-600 rounded px-2 py-0.5"
            data-testid={`section-locked-${title.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
          >
            <Lock className="h-3 w-3" />
            Locked
          </span>
        )}
      </div>
    </div>
  </div>
);

export default SectionHeader;
